import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Forum() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to home page with forum tab active
    navigate('/?tab=forum', { replace: true });
  }, [navigate]);

  return null;
}
